import { Suspense, lazy } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { Navigate, Outlet, useLocation } from 'react-router';

import { RegistrationContextProvider, SignUpAdvisorLayout } from '@zeta-commons';
import { LoadingScreen } from '@zeta-core';
import { RouterLinks } from '../../app-route-paths';
import { CompactErrorPage } from '../../layouts/compact-layout';
import AuthErrorBoundary from './logged-in-error-boundary';

const TermsRegisterationPage = lazy(() => import('../../pages/auth/signup/terms'));
const AdvisorDetailsRegisterationPage = lazy(() => import('../../pages/auth/signup/advisor-details'));
const PasswordSetUpRegisterationPage = lazy(() => import('../../pages/auth/signup/password-set-up'));
const PersonalDetailsRegisterationPage = lazy(() => import('../../pages/auth/signup/personal-details'));
const SignUpChooseAccountType = lazy(() => import('../../pages/auth/signup'));
const VerificationRegisterationPage = lazy(() => import('../../pages/auth/signup/verification'));
const RegistrationSuccess = lazy(() => import('../../pages/auth/signup/registration-success'));

const OutletWrapper = () => {
  const location = useLocation();
  return <Outlet context={location.state} />;
};

const SignUpRoutes = [
  {
    path: 'signup',
    element: (
      <ErrorBoundary FallbackComponent={CompactErrorPage}>
        <RegistrationContextProvider>
          <AuthErrorBoundary />
        </RegistrationContextProvider>
      </ErrorBoundary>
    ),
    children: [
      {
        path: '',
        children: [
          { element: <Navigate to={RouterLinks.registerationAccountType} replace />, index: true },
          {
            path: 'account-type',
            element: (
              <Suspense fallback={<LoadingScreen />}>
                <SignUpChooseAccountType />
              </Suspense>
            ),
          },
          {
            path: 'accounts',
            element: (
              <SignUpAdvisorLayout>
                <Suspense fallback={<LoadingScreen />}>
                  <OutletWrapper />
                </Suspense>
              </SignUpAdvisorLayout>
            ),
            children: [
              {
                path: 'terms',
                element: <TermsRegisterationPage />,
              },
              {
                path: 'advisor-details',
                element: <AdvisorDetailsRegisterationPage />,
              },
              {
                path: 'registration',
                element: <PersonalDetailsRegisterationPage />,
              },
              {
                path: 'verification',
                element: <VerificationRegisterationPage />,
              },
              {
                path: 'password-set-up',
                element: <PasswordSetUpRegisterationPage />,
              },
              {
                path: '',
                element: <Navigate to="fca-details" replace />,
              },
            ],
          },
          {
            path: '',
            element: <Navigate to="account-type" replace />,
          },
        ],
      },
      {
        path: 'success',
        element: <RegistrationSuccess />,
      },
      {
        path: '*',
        element: <Navigate to="account-type" replace />,
      },
    ],
  },
];

export default SignUpRoutes;
